<script setup>
import AppDate from '@/Components/UI/AppDate.vue';
</script>

<template>
    <AppDate v-bind="$attrs" source="browser" />
</template>
